import React from 'react';

// Lays children out at the 960×540 reference size and scales them to fit, so
// px-based fonts/paddings look identical in the classroom (which renders at
// real pixels and passes `boardScale`) and in the editor/preview (which
// already scale the whole slide and pass nothing).
const ReferenceScale = ({ scale = 1, children }) => {
  const s = typeof scale === 'number' && scale > 0 ? scale : 1;
  if (Math.abs(s - 1) < 0.001) return <div className="relative w-full h-full">{children}</div>;
  return (
    <div className="relative w-full h-full overflow-hidden">
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: `${100 / s}%`,
          height: `${100 / s}%`,
          transform: `scale(${s})`,
          transformOrigin: '0 0',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ReferenceScale;
